
let ListView = require("clover/panel/component/common/ListView.js");
let Http = require("clover/utils/Http")

QACommand = require("clover/debug/QACommand")
QAGUI = xClass("QAGUI")
var _instance = null
QAGUI.getInstance = function () {
    if (!_instance) {
        _instance = QAGUI.new()
    }
    return _instance
}

QAGUI.prototype.ctor = function () {
    this.data = []
    this.lastCmd = ""
    this.isShowing = false
}

QAGUI.prototype.print = function (msg, category) {
    if (this.data.length >= 200){
        this.data.shift()
    }
    this.data.push([category, msg])
    console.log("[QAGUI]["+category+"]"+msg)
    if (this.isShowing == true){
        this.listView.refresh(this.data.length-1)
    }
}

QAGUI.prototype.show = function () {
    let self = this
    if (self.isShowing == true){
        return
    }
    self.isShowing = true
    this.bg = cc.LayerColor.create(cc.color(0,0,0,100))
    cc.director.getRunningScene().addChild(this.bg, 100000)

    let scrollView = ListView.create(this);
    scrollView.setBounceEnabled(true);
    let downOffset = 100
    scrollView.setContentSize(display.width, display.height - downOffset);
    scrollView.setAnchorPoint(0, 1);
    scrollView.y = display.height
    this.bg.addChild(scrollView);
    this.listView = scrollView
    this.listView.setSwallowTouches(false)
    this.listView.refresh(0);

    self.hasResize = false
    self.itemViewCache = {}

    let closeSp = cc.Sprite.createWithSpriteFrameName("uilibrary/offbottom_light_x_normal.png")
    this.bg.addChild(closeSp)
    closeSp.setPosition(display.width - 50, display.height - 200)
    this.closeBtn = UIButton.create(closeSp)
    this.closeBtn.on(UIButtonEvent.Click, function () {
        self.bg.removeFromParent()
        self.isShowing = false
    })

    let showInputCmd = function(){
        let textInput = ccui.EditBox.create(cc.size(330, 100), "uilibrary/squarewhite", 1)//cdkey/cdkey_bg.png
        self.bg.addChild(textInput)
        textInput.setMaxLength(65535)
        textInput.setReturnType(1)
        textInput.setInputMode(1)
        textInput.setFont("Arial", 40)
        textInput.setFontColor(cc.c4b(184, 28, 68, 255))
        textInput.setAnchorPoint(0, 0.5)
        textInput.setPlaceholderFontSize(40)
        textInput.setPlaceHolder("请输入文本内容")
        textInput.y = 80
        textInput.registerScriptEditBoxHandler(function (event) {
    
        })
        var okBtn = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/b_green_cut.png", cc.rect(86, 52, 90 - 86, 54 - 52))
        okBtn.setContentSize(cc.size(164, 122))
        self.bg.addChild(okBtn)
        okBtn.setPosition(textInput.width + 100,50)
        let ok = cc.LabelTTF.create("确定")
        ok.setFontSize(40)
        ok.setPosition(80, 65)
        okBtn.addChild(ok)
        okBtn = UIButton.create(okBtn, true)
        okBtn.on(UIButtonEvent.Click, function () {
            cc.log("输入内容：",textInput.getString())
            let key = QACommand.getInstance().analyzeCommand(textInput.getString())
            Toast.make("输入命令:"+key)
            self.lastCmd = textInput.getString()
        })
        var lastBtn = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/b_green_cut.png", cc.rect(86, 52, 90 - 86, 54 - 52))
        lastBtn.setContentSize(cc.size(164, 122))
        self.bg.addChild(lastBtn)
        lastBtn.setPosition(textInput.width + 300,50)
        let last = cc.LabelTTF.create("上一个")
        last.setFontSize(40)
        last.setPosition(80, 65)
        lastBtn.addChild(last)
        lastBtn = UIButton.create(lastBtn, true)
        lastBtn.on(UIButtonEvent.Click, function () {
            cc.log("输入内容：",self.lastCmd)
            let key = QACommand.getInstance().analyzeCommand(self.lastCmd)
            Toast.make("输入命令:"+key)
        })
    }
    
    if (!__DEBUG && Http.hostQuery != "env=qa"){
        console.log("线上正式包检查")
        
        return
    }else{
        showInputCmd()
    }
}

QAGUI.prototype.delegate_getLength = function() {
    let self = this;
    return self.data? self.data.length: 0
}


QAGUI.prototype.delegate_getItemHeight = function(index) {
    let self = this;
    // return 40;
    console.log("[qa] delegate_getItemHeight", index, this.data[index])
    return this.data[index][2] || 30
}

QAGUI.prototype.delegate_renderItem = function(index, itemView) {
    let self = this;
    if (itemView == null) {
        itemView = cc.LabelTTF.create("")
        itemView.setFontSize(25)
        itemView.setDimensions(600, 0)
    }
    let itemData = self.data && self.data[index];
    if (itemData) {
        itemView.setString("["+itemData[0]+"]"+itemData[1])
    }
    if (self.hasResize == false){
        self.itemViewCache[index] = itemView
        if (index >= this.data.length - 1){
            console.log("[qa] delegate_renderItem last")
            self.hasResize = true
            setTimeout(function(){
                for (let i in self.itemViewCache){
                    const view = self.itemViewCache[i];
                    let content = view.getContentSize()
                    self.data[i][2] = content.height
                    console.log("[qa] set height", content.height)
                }
                self.listView.refresh()
            }, 1000)
        }
    } 

    return itemView;
}
module.exports = QAGUI
